import React from "react";
import { useHistory } from "react-router-dom";
import { Box } from "@mui/material";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { useTranslation } from "react-i18next";
export default function Back() {
  const { t } = useTranslation("common");
  const history = useHistory();
  return (
    <Box
      sx={{
        color: "#999999",
        display: "flex",
        alignItems: "center",
        padding: "0 20px 20px",
        width: "max-content",
      }}
      className="_cp fs-14"
      onClick={() => history.goBack()}
    >
      <ArrowBackIosIcon className="fs-14" sx={{ color: "#999999" }} />{" "}
      {t("back")}
    </Box>
  );
}
